var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMove = function SvgMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_280012)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_402_280012",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_402_280012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 21.3077L8.44238 17.75L9.15588 17.0365L11.5001 19.3807V14.5H12.5001V19.375L14.8386 17.0307L15.5579 17.75L12.0001 21.3077ZM6.25013 15.5577L2.69238 12L6.24438 8.448L6.95788 9.1615L4.61938 11.5H9.50013V12.5H4.62513L6.96938 14.8385L6.25013 15.5577ZM17.7501 15.5577L17.0366 14.8442L19.3809 12.5H14.5001V11.5H19.3751L17.0309 9.1615L17.7501 8.44225L21.3079 12L17.7501 15.5577ZM11.5001 9.5V4.61925L9.15588 6.96349L8.44238 6.25L12.0001 2.69225L15.5579 6.25L14.8444 6.96349L12.5001 4.61925V9.5H11.5001Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_280012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
};
export default SvgMove;